<template>
  <modal
    style="margin-left: 0; margin-top: 5px; overflow: hidden"
    :active="active"
    @close="handleCloseModal"
    v-if="activeTransactionRequest"
  >
    <div slot="title">
      View Transaction Request ({{ activeTransactionRequest.code }})
    </div>
    <form-wizard
      @on-complete="handleSave"
      @on-change="scrollToTop"
      title
      subtitle
      color="#8cc63f"
      finish-button-text="Update"
      shape="square"
    >
      <tab-content title="Plan Details" icon="ti-list">
        <div
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div style="padding-left: 0" class="col-6">
              <label>Plan ID</label>
              <input
                class="form-control"
                type="text"
                disabled
                :value="activeTransactionRequest.code"
              />
            </div>
            <div style="padding-right: 0" class="col-6">
              <label>Investor Code</label>
              <input
                class="form-control"
                type="text"
                disabled
                :value="activeTransactionRequest.investor_code"
              />
            </div>
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label>Action:</label>
              <input class="form-control" disabled :value="getActionType()" />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label>Amount</label>
              <input
                class="form-control"
                disabled
                :value="activeTransactionRequest.amount"
              />
            </div>
          </div>
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label>Payment Type</label>
              <input class="form-control" disabled :value="getPaymentType()" />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label>Status</label>
              <select style="" class="form-control" v-model="status">
                <option
                  v-for="status in statusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content
        v-if="activeTransactionRequest.paymentMethod != null"
        title="Bank Details"
        icon="ti-wallet"
      >
        <div
          v-if="activeTransactionRequest.payment_type == 'banktransfer'"
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="bankName">Bank Name</label>
              <input
                class="form-control"
                type="text"
                id="bankName"
                disabled
                :value="activeTransactionRequest.paymentMethod.bankName"
                placeholder="Enter recipient's bank name"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="bankAddress">Bank Address</label>
              <input
                class="form-control"
                type="text"
                id="bankAddress"
                disabled
                :value="activeTransactionRequest.paymentMethod.bankAddress"
                placeholder="Enter recipient's bank address"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="beneficiaryName">Beneficiary Name</label>
              <input
                class="form-control"
                type="text"
                id="beneficiaryName"
                disabled
                :value="activeTransactionRequest.paymentMethod.beneficiaryName"
                placeholder="Enter beneficiary name"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="beneficiaryAddress">Beneficiary Address</label>
              <input
                class="form-control"
                type="text"
                id="beneficiaryAddress"
                disabled
                :value="
                  activeTransactionRequest.paymentMethod.beneficiaryAddress
                "
                placeholder="Enter beneficiary address"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="iban">IBAN</label>
              <input
                class="form-control"
                type="text"
                id="iban"
                disabled
                :value="activeTransactionRequest.paymentMethod.iban"
                placeholder="Enter IBAN"
                required
              />
            </div>

            <div class="col-6" style="padding-right: 0">
              <label for="swiftBic">SWIFT Code</label>
              <input
                class="form-control"
                type="text"
                id="swiftBic"
                disabled
                :value="activeTransactionRequest.paymentMethod.swiftBic"
                placeholder="Enter SWIFT/BIC Code"
                required
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 10px; display: flex">
            <div class="col-6" style="padding-left: 0">
              <label for="accountNumber">Account Number</label>
              <input
                class="form-control"
                type="text"
                id="accountNumber"
                disabled
                :value="activeTransactionRequest.paymentMethod.accountNumber"
                placeholder="Enter account number"
                required
              />
            </div>
            <div class="col-6" style="padding-right: 0">
              <label for="accountCurrency">Account Currency</label>
              <input
                class="form-control"
                type="text"
                id="accountCurrency"
                disabled
                :value="activeTransactionRequest.paymentMethod.accountCurrency"
                placeholder="Enter account currency"
                required
              />
            </div>
          </div>
        </div>
        <div
          v-else-if="activeTransactionRequest.payment_type == 'blockchain'"
          style="
            display: flex;
            align-items: center;
            margin-top: 10px;
            flex-direction: column;
          "
        >
          <div class="col-12" style="margin-top: 10px">
            <label for="blockchainDetails.wallet_address"
              >USDT Wallet Address</label
            >
            <input
              class="form-control"
              type="text"
              id="blockchainDetails.wallet_address"
              v-model="activeTransactionRequest.paymentMethod.wallet_address"
              placeholder="Enter wallet number"
              required
            />
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </modal>
</template> 

<script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import TransactionRequestStorer from "../../../../storers/StoreTransactionRequest";
import { mapState } from "vuex";
import sweetAlert from "sweetalert2";

export default {
  data() {
    return {
      status: null,
      paymentTypes: [
        { id: "banktransfer", name: "Bank Transfer" },
        { id: "blockchain", name: "Blockchain" },
      ],
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      statusList: [
        { id: "pending-review", name: "Pending Review" },
        { id: "cancelled", name: "Cancelled" },
        { id: "completed", name: "Completed" },
      ],
      bankDetails: {
        bankName: "",
        bankAddress: "",
        beneficiaryName: "",
        beneficiaryAddress: "",
        swiftBic: "",
        iban: "",
        accountNumber: "",
        accountCurrency: "",
        consentSave: true,
      },
      blockchainDetails: {
        wallet_address: "",
        consentSave: true,
      },
    };
  },
  props: {
    active: Boolean,
    activeTransactionRequest: Object,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
    }),
  },
  updated() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      if (this.active) {
        const modalContent = document.querySelector(".modal-body");
        modalContent.scrollTo(0, 0);
      }
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    getPaymentType() {
      return this.paymentTypes.find((paymentType) => {
        return paymentType.id == this.activeTransactionRequest.payment_type;
      }).name;
    },
    getActionType() {
      return this.transactionTypes.find((transactionType) => {
        return transactionType.id == this.activeTransactionRequest.type;
      }).name;
    },
    handleSave() {
      this.$emit("saveRequest", {
        id: this.activeTransactionRequest.id,
        status: this.status,
      });
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    fillform() {
      // this.contract_id = this.activeTransactionRequest.contract_code;
      // this.investor_id = this.activeTransactionRequest.investor_code;
      // this.amount = this.activeTransactionRequest.amount;
      // this.type = this.activeTransactionRequest.type;
      // this.payment_type = this.activeTransactionRequest.payment_type;
      // if (this.payment_type == "banktransfer") {
      //   this.bankDetails = {
      //     bankName: this.activeTransactionRequest.paymentMethod.bankName,
      //     bankAddress: this.activeTransactionRequest.paymentMethod.bankAddress,
      //     beneficiaryName:
      //       this.activeTransactionRequest.paymentMethod.beneficiaryName,
      //     beneficiaryAddress:
      //       this.activeTransactionRequest.paymentMethod.beneficiaryAddress,
      //     swiftBic: this.activeTransactionRequest.paymentMethod.swiftBic,
      //     iban: this.activeTransactionRequest.paymentMethod.iban,
      //     accountNumber:
      //       this.activeTransactionRequest.paymentMethod.accountNumber,
      //     accountCurrency:
      //       this.activeTransactionRequest.paymentMethod.accountCurrency,
      //     consentSave: this.activeTransactionRequest.paymentMethod.consentSave,
      //   };
      // } else if (this.payment_type == "blockchain") {
      //   this.blockchainDetails = {
      //     wallet_address:
      //       this.activeTransactionRequest.paymentMethod.wallet_address,
      //     consentSave: this.activeTransactionRequest.paymentMethod.consentSave,
      //   };
      // }
      // this.blockchainDetails = this.activeTransactionRequest.blockchainDetails;
      this.status = this.activeTransactionRequest.status;
      // this.currency_id = this.activeInvestorReport.currency_id;
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.fillform();
      }
    },
  },
};
</script> 
<style>
.max-text {
  position: absolute;
  right: 25px;
  bottom: -5px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 12px;
  color: #8cc63f;
  font-weight: bold;
}
.max-text:hover {
  color: #0056b3;
}
label {
  margin: 0;
  align-items: center;
  display: flex;
}
input {
  font-size: 16px !important;
}
.form-group {
  display: flex;
  margin: 0;
}
h3 {
  font-size: 1.4rem;
  line-height: 1.4em;
  margin: 0;
  text-align: center;
  font-weight: bold;
}

.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 15px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  width: 80px;
  height: 80px;
  border-radius: 15px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-header {
  padding: 0 !important;
}
.vue-form-wizard .wizard-card-footer {
  padding: 10px 35px 0 35px !important;
}
.wizard-tab-content {
  padding-top: 0px !important;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/transactionRequestModal.vue